import { createEntityState, GenericEntityStateClass } from '../../core/state/entity.state';
import { inject, Injectable } from '@angular/core';
import { EntityService } from '../../core/services/entity.service';
import { SequenceEntity } from '../sequence.entity';
import { SubjectEntityService } from '../../subject/services/subject.entity.service';
import { ConsumerEntityService } from '../../consumer/services/consumer.entity.service';
import { ExamEntityService } from '../../lesson/exam/services/exam.entity.service';
import { ExerciseEntityService } from '../../lesson/exercise/services/exercise.entity.service';

export const STATE_NAME = 'sequenceEntity';

export const SequenceEntityState: GenericEntityStateClass<SequenceEntity> =
  createEntityState<SequenceEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class SequenceEntityService extends EntityService<SequenceEntity> {
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);
  private examEntityService = inject(ExamEntityService);
  private exerciseEntityService = inject(ExerciseEntityService);

  constructor() {
    super();
    this.resourceType = 'sequences';
    this.stateClass = SequenceEntityState;

    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
    this.registerRelation('exams', this.examEntityService);
    this.registerRelation('exercises', this.exerciseEntityService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): SequenceEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
